import gql from 'graphql-tag';

export default gql`
	query GetProvince($lat: String!, $lng: String!) {
		getProvince(lat: $lat, lng: $lng) {
			province
		}
	}
`;
